/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import pre from "../assets/img/pre.svg";
import more from "../assets/img/more.svg";
import { useEffect, useState } from "react";
import { annoHelper } from "../dal/annoHelper";
import { useNavigate, NavigateOptions } from 'react-router-dom';
import config from "../SysConfig.json";
import dayjs from "dayjs";

export const NewsHome = () => {
  const [allNews, setAllNews] = useState<any[]>([]);
  const [activePage, setActivePage] = useState(0);
  const [currPageGroup, setCurrPageGroup] = useState(0);
  const [annoCount, setAnnoCount] = useState(0);

  const navigate = useNavigate();

  const handleDecPageGroup = () => {
    if (currPageGroup !== 0) {
      setCurrPageGroup(currPageGroup - 1)
      setActivePage((currPageGroup - 1) * config.Pagination.page_group_size - 1)
    }

  }

  const handleIncPageGroup = () => {
    if (currPageGroup !== Math.floor(annoCount / config.Pagination.page_group_size)) {
      setCurrPageGroup(currPageGroup + 1)
      setActivePage((currPageGroup + 1) * config.Pagination.page_group_size - 1)
    }
  }

  const handleActivatePage = (pageNum: number) => {
    if ((pageNum - 1) < annoCount / config.Pagination.page_size)
      setActivePage(pageNum - 1)
  }



  const handleNewAll = () => {
    navigate('/newsall?init=true');
  }

  const loadData = async () => {
    const annos = await annoHelper.getOpenConditionalAnnoWithFilters('', config.Pagination.page_size, activePage, '', '');
    setAllNews(annos);
    const annosCount = await annoHelper.getOpenAnnoCountWithFilters('', '', '');
    setAnnoCount(annosCount.count);
  }
  useEffect(() => {
    loadData();
  }, [activePage]);
  return (
    <>
      <div className='newsh flex flex-col justify-between border-[3px] border-primary custom-shadow items !pb-2 p-4 sm:p-6 lg:p-0'>
        {
          allNews.slice(0, 4).map((anno) => {
            return (

              <div className='lg:border-b flex lg:flex-wrap items-center text-base xl:text-lg gap-x-4 gap-y-0 lg:pb-1'>
                <div className="flex gap-3 lg:order-2 flex-shrink-0 text-sm">
                  {
                    (anno.is_top) ?
                      <div className='bt-yellow w-20 lg:w-auto py-2 lg:py-0'>{anno.unit_name}</div> :
                      <div className='bt-purple w-20 lg:w-auto py-2 lg:py-0'>{anno.unit_name}</div>
                  }
                  <div className='hidden lg:block text-primary'>{anno.anno_tag}</div>
                </div>
                <a href={`/newsview?itemid=${anno.id}`} className='hover:underline clamp2 lg-clamp1 lg:w-full'>{anno.title}</a>
                <div className='hidden lg:block lg:order-3 text-sm ml-auto lg:text-primary'>{dayjs(anno.start_at).format('YYYY-MM-DD')}</div>
              </div>
            )
          })
        }

        <div className='rounded-lg bt-green text-base lg:text-lg cursor-pointer hover:opacity-80 mb-4 mt-2 mx-auto w-fit px-4 py-1 lg:hidden'
          onClick={handleNewAll}
        >查看更多</div>

        {/* <div className="text-center py-4 lg:pb-0 lg:hidden">
          <nav className="inline-flex items-center gap-3 lg:gap-4" aria-label="Pagination">
            <a className="hover:opacity-70 focus-visible:outline-none cursor-pointer" onClick={() => handleDecPageGroup()}>
              <span><img src={pre} alt='' /></span>
            </a>
            {
              Array.from({ length: config.Pagination.page_group_size }).map
                ((_, i) =>
                  (currPageGroup * config.Pagination.page_group_size + i + 1 === activePage + 1) ?
                    <a className="w-6 h-6 leading-6 hover:opacity-70 focus-visible:outline-none rounded-full text-white bg-primary cursor-pointer" onClick={() => handleActivatePage(currPageGroup * config.Pagination.page_group_size + i + 1)}>{activePage + 1}</a> :
                    <a className="w-6 h-6 leading-6 hover:opacity-70 focus-visible:outline-none text-primary cursor-pointer" onClick={() => handleActivatePage(currPageGroup * config.Pagination.page_group_size + i + 1)}>{currPageGroup * config.Pagination.page_group_size + i + 1}</a>
                )
            }
            <a className="hover:opacity-70 focus-visible:outline-none cursor-pointer" onClick={() => handleIncPageGroup()}>
              <span><img src={next} alt='' /></span>
            </a>
          </nav>
        </div> */}
      </div>

    </>
  )

}